import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile, NumPad } from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { ManualBetSection } from './manualBetSection';
import { AutoplaySection } from './autoplaySection';
import {
  GameResponseTypeName,
  globalTranslationKeys,
  numberOfRoundsEnum,
  numPadTypes,
} from '../../../enums';
import {
  autoPlayBetStore,
  doBetStore,
  gameStore,
  inputValidationStore,
  manualBetStore,
} from '../../../store';
import { NumPadWr } from '../../mobile/numPad';
import { useClickOutside } from '../../../hooks/useClickOutside';

let mobileWrRef;
export const BettingPart = observer(({ t }) => {
  const { Manual, Autoplay } = globalTranslationKeys;
  const { isAutoPlayMode, isStartAutoPlay, isAutoBetAccepted } = autoPlayBetStore;
  const { gameConfiguration: { autobet: isAutoBetConfigEnabled } = {} } = gameConfigStore;
  const disabled = isAutoPlayMode ? isStartAutoPlay || isAutoBetAccepted : doBetStore.disabled;

  const { limits } = gameConfigStore;
  const { sectionName, isOpenNumpad } = gameStore.numPadData;
  const [ref, hasClickedOutside] = useClickOutside();
  const [namPudInputValue, updateNumPudInputValue] = useState(limits.minBet);
  const [dynamicNamPudLimits, updateDynamicNumPudLimits] = useState({
    minBet: limits.minBet,
    maxBet: limits.maxBet,
  });

  useLayoutEffect(() => {
    mobileWrRef = document.querySelector('.mobile-wr');
  }, []);

  useEffect(() => {
    if (hasClickedOutside) {
      gameStore.setNumPadData({
        isOpen: false,
        sectionName: null,
        sectionMarket: null,
        currentInputValue: null,
      });
    }
  }, [hasClickedOutside]);

  const handleSubmit = (isConfirmed) => {
    const {
      manualBetValue,
      manualCashOut,
      baseBetAmount,
      autoCashOutOdd,
      winLossIncrease,
      stopIfLossEndRounds,
    } = numPadTypes;
    const setNumPudValueBySectionName = {
      [manualBetValue]: () => {
        return inputValidationStore.setDefaultValueNumpad(
          namPudInputValue,
          manualBetStore.setBetAmount,
          gameStore.numPadData.numPadLimits,
          gameStore.numPadData.sectionMarket,
          GameResponseTypeName.Bet
        );
      },
      [manualCashOut]: () => {
        return inputValidationStore.setDefaultValueNumpad(
          namPudInputValue,
          manualBetStore.setAutoCashOutOdd,
          gameStore.numPadData.numPadLimits,
          gameStore.numPadData.sectionMarket,
          GameResponseTypeName.AutoCashOut
        );
      },
      [baseBetAmount]: () => {
        return inputValidationStore.setDefaultValueNumpad(
          namPudInputValue,
          autoPlayBetStore.setBaseBetAmountValue,
          gameStore.numPadData.numPadLimits,
          null,
          GameResponseTypeName.Bet
        );
      },
      [autoCashOutOdd]: () => {
        return inputValidationStore.setDefaultValueNumpad(
          namPudInputValue,
          autoPlayBetStore.setAutoCashOutValue,
          gameStore.numPadData.numPadLimits,
          null,
          GameResponseTypeName.AutoCashOut
        );
      },
      [winLossIncrease]: () => {
        return inputValidationStore.setDefaultValueNumpad(
          namPudInputValue,
          autoPlayBetStore.setOnWinLossIncreaseValue,
          gameStore.numPadData.numPadLimits,
          gameStore.numPadData.sectionMarket,
          GameResponseTypeName.OnInc
        );
      },
      [stopIfLossEndRounds]: () => {
        return inputValidationStore.setDefaultValueNumpad(
          Number.isInteger(+namPudInputValue) ? namPudInputValue : Math.trunc(namPudInputValue),
          autoPlayBetStore.setAutoplayStopCount,
          gameStore.numPadData.numPadLimits,
          gameStore.numPadData.sectionMarket,
          numberOfRoundsEnum === gameStore.numPadData.sectionMarket
            ? GameResponseTypeName.StopNumberOfRounds
            : GameResponseTypeName.StopIfLoss
        );
      },
    };

    if (isConfirmed) {
      setNumPudValueBySectionName?.[sectionName]();
      gameStore.setNumPadData({
        isOpen: false,
        sectionName: null,
        sectionMarket: null,
        currentInputValue: null,
        numPadLimits: {},
      });
    }
  };
  const handleOpenNumPad = useCallback(
    (event, openedNumpadName, market = null, numPadLimits = null) => {
      updateDynamicNumPudLimits((state) => {
        return { ...state, minBet: numPadLimits.incDec, maxBet: numPadLimits.maxValue };
      });

      if (isMobile()) {
        updateNumPudInputValue(event.target.value);
        gameStore.setNumPadData({
          isOpenNumpad: true,
          sectionName: openedNumpadName,
          sectionMarket: market,
          currentInputValue: event.target.value,
          numPadLimits: numPadLimits,
        });
      }
    },
    [isOpenNumpad]
  );

  return (
    <div className='crash-bet'>
      <div className='crash-bet-inside'>
        {/* For crash-bet-tabs add class or attribute // disabled // to disable it */}
        <div className={`crash-bet-tabs ${disabled ? 'disabled' : ''} `}>
          <div className='crash-bet-tabs-holder'>
            <div
              className={`crash-bet-tab  ${!isAutoPlayMode ? 'active' : ''}`}
              onClick={() => autoPlayBetStore.setIsAutoPlayMode(false)}
            >
              <p className='crash-bet-tab-txt' title={t(Manual)}>
                {t(Manual)}
              </p>
            </div>
            {isAutoBetConfigEnabled && (
              <div
                className={`crash-bet-tab  ${isAutoPlayMode ? 'active' : ''}`}
                onClick={() => autoPlayBetStore.setIsAutoPlayMode(true)}
              >
                <p className='crash-bet-tab-txt' title={t(Autoplay)}>
                  {t(Autoplay)}
                </p>
              </div>
            )}
            <div className='crash-bet-tab-bg'>
              <div className='crash-bet-tab-bg-inside' />
            </div>
          </div>
        </div>
        {isAutoPlayMode ? (
          <AutoplaySection t={t} handleOpenNumPad={handleOpenNumPad} />
        ) : (
          <ManualBetSection t={t} handleOpenNumPad={handleOpenNumPad} />
        )}
      </div>
      <NumPadWr containerRef={mobileWrRef}>
        <div ref={ref} className='numpad-wr-for-outside-click'>
          <NumPad
            t={t}
            isOpen={isOpenNumpad}
            limits={dynamicNamPudLimits}
            onSubmit={handleSubmit}
            amountValue={namPudInputValue}
            setAmountValue={updateNumPudInputValue}
          />
        </div>
      </NumPadWr>
    </div>
  );
});
